
import http from "../http-common";

class PdfService {
  create(data) {
    return http.post("/pdfs", data);
  }

  createUserCert(data) {
    return http.post("/pdfs/user", data);
  }

  get(certificateNumber) {
    return http.get(`/pdfs/${certificateNumber}`);
  }

  getUserCert(userExamID) {
    return http.get(`/pdfs/user/${userExamID}`);
  }

  sendResults(certificateID) {
    return http.put(`/pdfs/${certificateID}`);
  }

  sendUserCert(userExamID) {
    return http.put(`/pdfs/user/${userExamID}`);
  }
}

export default new PdfService();